// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"87":"industry","589":"park","683":"city","879":"call","996":"info"}[chunkId] + "." + {"87":"ab0fc990","589":"1a7c99bc","683":"412edb48","879":"d812b7e2","996":"f5e3334b"}[chunkId] + ".css";
};